import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Dropdown } from './dropdown/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    Dropdown
  ],
  imports: [
    CommonModule,
    AutoCompleteModule,
    FormsModule,
    SelectModule,
    TranslateModule,
],
  exports: [
    Dropdown,
  ]
})
export class DropdownModule { }
